export default "__VITE_ASSET__BvPGP4ju__";